module.exports = __webpack_public_path__ + "img/7_b.8f798cfa.jpg";